import { request } from "../../Services/Api"

export const getPricing = ({ all, ...params }) => {
  if (all) {
    return request.api.get("/billing/pricing/users-pricing/")
  } else {
    return request.api.get(`/billing/pricing/`, params)
  }
}
export const getPricingFilterOptions = () => request.api.get("/billing/pricing/filter_options/")
export const getPricingExport = ({ file_name, ...params }) =>
  request.api.get(`/billing/pricing/export/`, params)
export const createPricing = (data) => {
  if (data.type === "Volume based") {
    return request.api.post(`/billing/pricing/create_volume_based_pricing/`, data)
  }
  return request.api.post(`/billing/pricing/`, data)
}
export const updatePricing = ({ id, type, ...data }) => {
  if (type === "Volume based") {
    return request.api.patch(`/billing/pricing/${id}/update_volume_based_pricing/`, data)
  } else {
    return request.api.put(`/billing/pricing/${id}/`, data)
  }
}
export const deletePricing = (id) => request.api.delete(`/billing/pricing/${id}/`)
